// extracted by mini-css-extract-plugin
export default {"LinkPlus":"LinkPlus_LinkPlus__0Ul3G"};